import { styled, Typography, TypographyProps } from '@mui/material';
import { Box } from '@mui/material';

const GlowRoot = styled(Box, {
  name: 'Glow',
  slot: 'root',
})({
  position: 'relative',
});

const GlowText = styled(Typography, {
  name: 'Glow',
  slot: 'text',
})({
  color: '#fff',
  textShadow: '0px 0px 72px rgba(255, 255, 255, 0.72)',
  width: '100%',
});

const GlowBlur = styled(Typography, {
  name: 'Glow',
  slot: 'blur',
})({
  position: 'absolute',
  top: 0,
  left: 0,
  filter: 'blur(12px)',
  color: '#FFC87B',
  opacity: 0.72,
  width: '100%',
  userSelect: 'none',
  pointerEvents: 'none',
});

export function GlowTypography(props: TypographyProps) {
  return (
    <GlowRoot>
      <GlowText {...props} />
      <GlowBlur {...props} aria-hidden="true" />
    </GlowRoot>
  );
}
